import { spErrorTags } from '@eventr/common'

// IndexedDB wrapper class
export class IndexedDB {
    db: IDBDatabase | null
    // connect to IndexedDB database
    constructor(dbName: any, dbVersion: any, dbUpgrade: any) {
        // connection object
        this.db = null
        // no support
        if (!('indexedDB' in window)) {
            spErrorTags('IndexedDB not supported', ['IDB'])
            throw new Error('IndexedDB not supported')
        }
        // open database
        const dbOpen = indexedDB.open(dbName, dbVersion)
        if (dbUpgrade) {
            // database upgrade event
            dbOpen.onupgradeneeded = (e) => {
                dbUpgrade(dbOpen.result, e.oldVersion, e.newVersion)
            }
        }
        dbOpen.onsuccess = () => {
            // spLogTags('IndexedDB opened', ['IDB', dbName])
            this.db = dbOpen.result
        }
        dbOpen.onerror = (e) => {
            spErrorTags('IndexedDB failed to open', ['IDB'])
        }
    }
    // store item
    set(storeName: any, name: any, value: any) {
        return new Promise((resolve, reject) => {
            if (!this.db) {
                spErrorTags('IndexedDB not open', ['IDB'])
                return
            }
            if (!this.db.objectStoreNames.contains(storeName)) {
                spErrorTags('IndexedDB store does not exist', ['IDB'])
                return
            }
            // new transaction
            const transaction = this.db.transaction(storeName, 'readwrite'),
                store = transaction.objectStore(storeName)
            // write record
            store.put(value, name)
            transaction.oncomplete = () => {
                resolve(true) // success
            }
            transaction.onerror = () => {
                reject(transaction.error) // failure
            }
        })
    }
    // get named item
    get<T>(storeName: any, name: any) {
        return new Promise<T>((resolve, reject) => {
            if (!this.db) {
                spErrorTags('IndexedDB not open', ['IDB'])
                return
            }
            if (!this.db.objectStoreNames.contains(storeName)) {
                spErrorTags('IndexedDB store does not exist', ['IDB'])
                return
            }
            // new transaction
            const transaction = this.db.transaction(storeName, 'readonly'),
                store = transaction.objectStore(storeName),
                // read record
                request = store.get(name)
            request.onsuccess = () => {
                resolve(request.result as T) // success
            }
            request.onerror = () => {
                reject(request.error) // failure
            }
        })
    }
}
